import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import CartIcon from '@/assets/templates/icons/cartIcon'

import Layout from './landscape-photographer.views'

const LandscapeHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Header>
        <CommonComponents.Wrapper>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Navigation>
            <Layout.Link>About Me</Layout.Link>
            <Layout.Link>Services</Layout.Link>
            <Layout.Link>Portfolio</Layout.Link>
            <CartIcon />
          </Layout.Navigation>
        </CommonComponents.Wrapper>
      </Layout.Header>
      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage}>
        <Layout.HeroContainer>
          <Layout.TitleContainer>
            <Layout.Title>{template.sections.hero.title}</Layout.Title>
          </Layout.TitleContainer>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default LandscapeHero
